import { render, staticRenderFns } from "./producer_submit_success.vue?vue&type=template&id=28cb546d&scoped=true"
import script from "./producer_submit_success.vue?vue&type=script&lang=js"
export * from "./producer_submit_success.vue?vue&type=script&lang=js"
import style0 from "./producer_submit_success.vue?vue&type=style&index=0&id=28cb546d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb546d",
  null
  
)

export default component.exports